import { OrdemCompraAbas, OrdemCompraDadosGerais, OrdemCompraDadosIdentificacao } from "@app/api/sas/ordemCompra";
import { ISasPropostaOrdemCompra, ISasPropostaOrdemCompraDocs } from "@app/api/sas/sasProposta";
import { StepsTimeline } from "@app/api/status";
import TipoOptions from "@app/types/core.types";
import { atom } from "recoil";

export interface EditandoStateInfo {
  sasPropostaId: string;
  ordemCompraFluxoProcessoId?: string;
  ordemCompraRodadaNegociacaoId?: string;
  justificativa?: string;
}

export const dadosGeraisState = atom({
  key: 'dadosGeraisState',
  default: {} as OrdemCompraDadosGerais,
});

export const dadosIdentificacaoState = atom({
  key: 'dadosIdentificacaoState',
  default: {} as OrdemCompraDadosIdentificacao,
});

export const ordemCompraIdState = atom({
  key: 'ordemCompraIdState',
  default: '',
});

export const ordemCompraAbasState = atom({
  key: 'ordemCompraAbasState',
  default: {} as OrdemCompraAbas,
});

export const reloadAbaStateState = atom({
  key: 'reloadAbaStateState',
  default: false,
});

export const ordemCompraRodadaNegociacaoIdState = atom({
  key: 'ordemCompraRodadaNegociacaoIdState',
  default: undefined as string | undefined,
});

export const reloadState = atom({
  key: 'reloadState',
  default: false,
});

export const reloadVendorListState = atom({
  key: 'reloadVendorListState',
  default: false,
});

export const vendorListState = atom({
  key: 'vendorListState',
  default: [] as ISasPropostaOrdemCompra[],
});

export const vendorListDocsState = atom({
  key: 'vendorListDocsState',
  default: [] as ISasPropostaOrdemCompraDocs[],
});

export const reloadWidgetTimelineState = atom({
  key: 'reloadWidgetTimelineState',
  default: false,
});

export const statusCodigoState = atom({
  key: 'statusCodigo',
  default: 0,
});

export const reloadDatasState = atom({
  key: 'reloadDatasState',
  default: false,
});

export const allStepsState = atom({
  key: 'allStepsState',
  default: [] as StepsTimeline[],
});

export const stepState = atom({
  key: 'stepState',
  default: {} as StepsTimeline,
});

export const proxStepState = atom({
  key: 'proxStepState',
  default: {} as StepsTimeline,
});

export const anteriorStepState = atom({
  key: 'anteriorStepState',
  default: {} as StepsTimeline,
});

export const fluxoProcessoState = atom({
  key: 'fluxoProcessoState',
  default: '',
});

export const reloadAnexosState = atom({
  key: 'reloadAnexosState',
  default: false,
});

export const showModalDesobrigarConfideIdState = atom({
  key: 'showModalDesobrigarConfideIdState',
  default: '',
});

export const demandaIdState = atom({
  key: 'demandaIdState',
  default: '',
});

export const modalAcoesIdState = atom({
  key: 'modalAcoesIdState',
  default: '',
});

export const editandoState = atom({
  key: 'editandoState',
  default: {} as EditandoStateInfo,
});

export const gestorOptionsState = atom({
  key: 'gestorOptionsState',
  default: [] as TipoOptions[],
});

export const gerenteAreaOptionsState = atom({
  key: 'gerenteAreaOptionsState',
  default: [] as TipoOptions[],
});

export const reloadWidgetIdentificacaoState = atom({
  key: 'reloadWidgetIdentificacaoState',
  default: false,
});

export const ajustarStepOnReloadState = atom({
  key: 'ajustarStepOnReloadState',
  default: true,
});

export const reloadDadosGeraisState = atom({
  key: 'reloadDadosGeraisState',
  default: false,
});

export const desabilitarAcoesState = atom({
  key: 'desabilitarAcoesState',
  default: false,
});

export const ajustarProxStepByAPIState = atom({
  key: 'ajustarProxStepByAPIState',
  default: false,
});